import { ServiceValues } from '../values/ServiceValues';
import { ServiceAxios } from './ServiceEW';
import { Values } from '../values/Values';

async function getAllPacotes(limit, page) {
  try {
    const timeout = ServiceValues.timeout;
    const baseUrl = ServiceValues.base_url_local;
    const api = ServiceAxios(baseUrl, timeout);
    const params = {
      limit: limit,
      page: page
    };
    const dados = await api.get('pacotes/', { params: params });
    if (dados) {
      if (dados.data) {
        return dados.data;
      }
      else {
        return {
          isSuccess: false,
          message: Values.MessageValues.erro_catch,
          result: []
        }
      }
    }
    else {
      return {
        isSuccess: false,
        message: Values.MessageValues.erro_catch,
        result: []
      };
    }

  } catch (e) {
    return {
      isSuccess: false,
      message: Values.MessageValues.erro_catch,
      result: []
    };

  }
}



export {getAllPacotes};
